var map = {
	"./ages/adult.svg": 602,
	"./ages/old.svg": 603,
	"./ages/teen.svg": 604,
	"./ages/young.svg": 605,
	"./astronaut.svg": 606,
	"./error.svg": 607,
	"./marked-tag.svg": 320,
	"./no-data.svg": 322,
	"./rock.svg": 321,
	"./test_export.jpg": 608,
	"./verified.png": 574,
	"./wave.svg": 319
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1024;